import { isAddressEqual } from "@opensea/utils"
import { isAddress } from "viem"
import { z } from "zod"
import { addressSchema } from "../../../lib/zod/address"
import { expirationSchema } from "../../../lib/zod/expiration"
import { orderSchema } from "../../../lib/zod/schema"
import { MINIMUM_LISTING_PRICE } from "../constants"

const listingSchema = orderSchema
  .safeExtend({
    price: z
      .float64({
        error: () => "",
      })
      .gte(
        MINIMUM_LISTING_PRICE,
        `Listing price must be at least ${MINIMUM_LISTING_PRICE} ETH`,
      )
      .superRefine((value, ctx) => {
        const decimals = value.toString().split(".")[1] || ""
        if (decimals.length > 14) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Maximum 14 decimal places allowed",
          })
        }
      }),
    traitFloorPrice: z.float64().optional(),
    ownedQuantity: z.int(),
    listingSymbol: z.string(),
  })
  .superRefine((data, ctx) => {
    if (data.quantity > data.ownedQuantity) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "You don't have enough of this item.",
        path: ["quantity"],
      })
    }
  })

export const listingFlowFormSchema = z.object({
  adjustForFees: z.boolean(),
  applyCreatorFee: z.boolean(),
  expiration: expirationSchema,
  listings: z.array(listingSchema),
  reservedBuyer: addressSchema.superRefine(
    ({ resolvedAddress, identifier, currentAddress }, ctx) => {
      const address = resolvedAddress ?? identifier

      if (!(address && isAddress(address))) {
        return
      }

      if (isAddressEqual(address, currentAddress)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "You cannot reserve a listing for yourself.",
          path: ["identifier"],
        })
      }
    },
  ),
})
